
























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LaporanOperasi from "@/services/LaporanOperasi";
import { LaporanOperasi as LapOpType } from "@/types/laporan_operasi";
import LaporanOperasiInput from "@/pages/pemeriksaan_ranap/LaporanOperasiInput.vue";
import {
  laporanOperasiHeaders,
  namaTindakanLabel,
  tglOperasi
} from "@/utils/laporanOperasi";

@Component({
  components: {
    LaporanOperasiInput
  }
})
export default class LaporanOperasiRiwayat extends Vue {
  @Prop() readonly rm!: string | number;

  items: LapOpType[] = [];
  loading = false;
  detail: LapOpType | null = null;
  requestSeq = 0;

  get headers() {
    return laporanOperasiHeaders(!!this.detail);
  }

  @Watch("rm", { immediate: true })
  onRmChange() {
    this.items = [];
    this.detail = null;
    this.load();
  }

  async load() {
    const rm = this.rm;
    if (!rm) return;

    const seq = ++this.requestSeq;
    this.loading = true;
    try {
      const resp = await LaporanOperasi.getByRm(rm);
      if (seq !== this.requestSeq || rm !== this.rm) return;
      this.items = resp.data || [];
      if (this.detail) {
        const id = this.detail.id;
        const fresh = this.items.find(itm => itm.id === id);
        this.detail = fresh ? JSON.parse(JSON.stringify(fresh)) : null;
      }
    } catch {
      if (seq === this.requestSeq) this.items = [];
    } finally {
      if (seq === this.requestSeq) this.loading = false;
    }
  }

  lihatDetail(item: LapOpType) {
    this.detail = JSON.parse(JSON.stringify(item));
  }

  namaTindakanLabel(item: LapOpType): string {
    return namaTindakanLabel(item);
  }

  tglOperasi(dateString: string | undefined): string {
    return tglOperasi(dateString);
  }

  previewForm(id: number) {
    LaporanOperasi.print(id);
  }
}
